import { StorePreview } from './StorePreview';

export default StorePreview;
